module.exports = __webpack_public_path__ + "img/history9.af09add4.jpg";